var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { OauthApiService } from '@ClientApi/oauth';
export const OAUTH_TOKENS_SET_LOADING = 'OAUTH_TOKENS_SET_LOADING';
export const OAUTH_TOKENS_SET_TOKENS = 'OAUTH_TOKENS_SET_TOKENS';
export class SetLoading {
    constructor(loading) {
        this.type = OAUTH_TOKENS_SET_LOADING;
        this.payload = loading;
    }
}
export class SetTokens {
    constructor(tokens) {
        this.tokens = tokens;
        this.type = OAUTH_TOKENS_SET_TOKENS;
        this.payload = tokens;
    }
}
export const init = (dispatch) => () => __awaiter(void 0, void 0, void 0, function* () {
    dispatch(new SetLoading(true));
    const tokens = yield OauthApiService.getUserTokens();
    dispatch(new SetTokens(tokens));
});
export const revoke = (dispatch) => (id) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch(new SetLoading(true));
    const tokens = yield OauthApiService.revoke(id);
    dispatch(new SetTokens(tokens));
});
